import { AfterViewInit, Component, OnInit } from '@angular/core';
import { EmitterService } from '../common/services/emitter.service';
import { CommonConstants } from '../common/utilities/commonConstants';
import { SharedService } from 'src/app/common/services/sharedService';
import { RouteContextProvider } from '../common/services/routeContextProvider.service';
import { SessionHandlerService } from '../common/services/sessionHandler.service';
@Component({
    // tslint:disable-next-line:component-selector
    selector: 'customHeader',
    templateUrl: './header.template.html',
    styleUrls: ['./header.style.scss']
})
export class HeaderComponent implements OnInit, AfterViewInit {
    public ishealthExtraCarePlusMobileApp = false;
    public ShowProgressInfo = false;
    public ProgressStateInfo: Model.ProgressStateInfo[];
    public bflJourney: boolean = false;
    isMobile: any;
    constructor(
        private _emitterService: EmitterService,
        public sharedService: SharedService,
        private _routeContextProvider: RouteContextProvider,
        private _sessionHandlerService: SessionHandlerService,
    ) {
    }

    ngOnInit() {
        this._emitterService.Get(CommonConstants.EmitterEventTypes.ProgressStateEvent).subscribe(
            (progressStateInfo: Model.ProgressStateInfo[]) => {
                this.ProgressStateInfo = progressStateInfo;
                console.log('app.component: ' + progressStateInfo);
                this.ShowProgressInfo = true;
            });
        // Mobile header hide
        this._emitterService.Get(CommonConstants.EmitterEventTypes.MobileAppCheck).subscribe(
            (Key: string) => {
                if (Key === '1') {
                    this.ishealthExtraCarePlusMobileApp = true;
                }
            });
        let url: any = window.location.pathname;
        url = url.split("/");
        this.bflJourney = this.sharedService.isBFLJourney();
        this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.bflJourney, this.bflJourney);
        this.isMobile = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.IsMobile);

        this.hideLogo();
    }

    ngAfterViewInit(): void {
        this.hideLogo();
    }

    hideLogo() {
        if (this.bflJourney) {
            document.getElementById('bfl-Logo-light1').style.display = 'block';
            document.getElementById('bfdl-Logo-light1').style.display = 'none';
        } else {
            document.getElementById('bfdl-Logo-light1').style.display = 'block';
            document.getElementById('bfl-Logo-light1').style.display = 'none';
        }
    }

    navigateToBFLPage(){
        window.open(CommonConstants.bflHomePageUrl, '_blank');
    }
}
